// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__pUO9w","placeholder":"Select_placeholder__cDSrc","error":"Select_error__lTddr"};